import { useState } from "react";
import { DEFAULT_ADMINS } from "../constants";

export function UserAdminPanel({ users, onUpdate, onClose }) {
  const [newEmail, setNewEmail] = useState("");
  const [newRole, setNewRole] = useState("user");

  const addUser = () => {
    const email = newEmail.trim().toLowerCase();
    if (!email || !email.includes("@")) return;
    if (users.some(u => u.email === email)) return;
    onUpdate([...users, { email, role: newRole }]);
    setNewEmail("");
    setNewRole("user");
  };

  const removeUser = (email) => {
    if (DEFAULT_ADMINS.includes(email)) return;
    onUpdate(users.filter(u => u.email !== email));
  };

  const toggleRole = (email) => {
    if (DEFAULT_ADMINS.includes(email)) return;
    onUpdate(users.map(u => u.email === email ? { ...u, role: u.role === "admin" ? "user" : "admin" } : u));
  };

  return (
    <div style={{ position:"fixed", inset:0, zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", background:"rgba(0,0,0,0.6)", backdropFilter:"blur(4px)" }} onClick={onClose}>
      <div style={{ background:"#212737", border:"1px solid rgba(255,197,67,0.2)", borderRadius:14, padding:28, width:480, maxHeight:"80vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.5)" }} onClick={e => e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div style={{ fontFamily:"'Raleway',sans-serif", fontSize:16, fontWeight:700, color:"#ffc543" }}>Manage Users</div>
          <button onClick={onClose} style={{ background:"none", border:"none", color:"#75788b", fontSize:20, cursor:"pointer" }}>✕</button>
        </div>

        {/* Add user */}
        <div style={{ display:"flex", gap:8, marginBottom:20 }}>
          <input
            style={{ flex:1, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:7, padding:"8px 12px", color:"#fff", fontSize:13, outline:"none" }}
            placeholder="email@easy-skill.com"
            value={newEmail}
            onChange={e => setNewEmail(e.target.value)}
            onKeyDown={e => e.key === "Enter" && addUser()}
          />
          <select
            style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:7, padding:"8px 10px", color:"#fff", fontSize:12 }}
            value={newRole} onChange={e => setNewRole(e.target.value)}
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
          <button onClick={addUser} style={{ background:"#31b4a6", color:"#fff", border:"none", borderRadius:7, padding:"8px 16px", cursor:"pointer", fontSize:12, fontWeight:600 }}>
            Add
          </button>
        </div>

        {/* User list */}
        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
          {users.map(u => (
            <div key={u.email} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:8, padding:"10px 14px" }}>
              <div>
                <div style={{ fontSize:13, color:"#fff", fontWeight:500 }}>{u.email}</div>
                <div style={{ fontSize:10, color: u.role === "admin" ? "#ffc543" : "#75788b", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.08em" }}>{u.role}{DEFAULT_ADMINS.includes(u.email) ? " (default)" : ""}</div>
              </div>
              {!DEFAULT_ADMINS.includes(u.email) && (
                <div style={{ display:"flex", gap:6 }}>
                  <button onClick={() => toggleRole(u.email)} style={{ background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:6, padding:"5px 10px", color:"#75788b", fontSize:11, cursor:"pointer" }}>
                    {u.role === "admin" ? "Demote" : "Promote"}
                  </button>
                  <button onClick={() => removeUser(u.email)} style={{ background:"rgba(224,128,112,0.1)", border:"1px solid rgba(224,128,112,0.2)", borderRadius:6, padding:"5px 10px", color:"#e08070", fontSize:11, cursor:"pointer" }}>
                    Remove
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
